import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'

const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string) {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

type ApiError = Error & { statusCode: number }

async function apiFetch<T>(method: string, path: string): Promise<T> {
  const token = Cookies.get('token')
  const headers: Record<string, string> = {}
  if (token) headers.Authorization = `Bearer ${token}`
  const res = await fetch(buildUrl(path), { method, headers })
  if (res.status === 204) return undefined as T
  if (!res.ok) {
    if (res.status === 401 && token) {
      handleSessionExpired()
      const err = new Error('Session expired') as ApiError
      err.statusCode = 401
      throw err
    }
    const payload = await res.json().catch(() => null)
    const details = Array.isArray(payload?.error?.details) ? payload.error.details : null
    const detailMessage = details?.length
      ? details.map((d: { field?: string; message?: string }) => d.message || d.field).join('; ')
      : null
    const err = new Error(detailMessage || payload?.error?.message || payload?.message || res.statusText || 'Request failed') as ApiError
    err.statusCode = res.status
    throw err
  }
  return res.json()
}

export async function getSlackOAuthUrl(workspaceId: string): Promise<string> {
  const data = await apiFetch<{ url: string }>('GET', `/api/workspaces/${workspaceId}/slack/oauth/start`)
  return data.url
}

export async function disconnectSlack(workspaceId: string): Promise<void> {
  await apiFetch<void>('DELETE', `/api/workspaces/${workspaceId}/slack`)
}
